<template>
  <div
    class="sn-date-picker"
  >
    <label
      v-if="title"
      v-html="title"
    />
    <v-menu
      ref="menu"
      :close-on-content-click="true"
      transition="scale-transition"
      offset-y
      min-width="auto"
    >
      <template v-slot:activator="{ on, attrs }">
        <v-text-field
          :id="snInputProps_identifier"
          :value="computedDate"
          :autocapitalize="autocapitalize"
          :autofocus="snInputProps_autofocus"
          :class="snInputProps_classes"
          :error-messages="errorMessages"
          :placeholder="snInputProps_disabled ? null : placeholder"
          :hint="hint"
          :name="snInputProps_identifier"
          :required="snInputProps_required"
          :disabled="snInputProps_disabled"
          :aria-label="snInputProps_label"
          :maxlength="maxLength <= 0 ? undefined : maxLength"
          :hide-details="snInputProps_hideDetails"
          :max="max"
          :type="type"
          :inputmode="inputMode"
          :pattern="pattern"
          :prepend-inner-icon="innerIcon"
          :rules="rules"
          autocomplete="nope"
          outlined
          readonly
          v-bind="attrs"
          append-icon="$snCalendar"
          v-on="on"
          @mouseup="$emit('mouseup')"
          @keydown="$emit('keydown')"
          @keyup="$emit('keyup')"
          @blur="$emit('blur')"
          @focus="$emit('focus')"
        />
      </template>
      <v-date-picker
        v-model="response"
        no-title
        scrollable
        :min="minDate"
        :max="maxDate"
        prev-icon="$snChevronLeft"
        next-icon="$snChevronRight"
      />
    </v-menu>
  </div>
</template>

<script>
import SnInputProps from '../../../../../../app/javascript/components/snui/v2/props/SnInputProps'

export default {
  name: 'SnDatePicker',

  props: {
    ...SnInputProps,
    errorMessages: {
      type: Array,
      default: () => [],
      required: false
    },
    rules: {
      type: Array,
      default: () => [],
      required: false
    },
    autocapitalize: {
      type: String,
      default: '',
      required: false
    },
    placeholder: {
      type: String,
      default: '',
      required: false
    },
    inputMode: {
      type: String,
      default: 'text',
      required: false
    },
    pattern: {
      type: String,
      default: null,
      required: false
    },
    maxLength: {
      type: Number,
      default: null,
      required: false
    },
    max: {
      type: String,
      default: null,
      required: false
    },
    minDate: {
      type: String,
      default: '',
      required: false
    },
    maxDate: {
      type: String,
      default: '',
      required: false
    },
    hint: {
      type: String,
      default: '',
      required: false
    },
    type: {
      type: String,
      default: 'text',
      required: false
    },
    innerIcon: {
      type: String,
      default: null,
      required: false
    },
    mask: {
      type: String,
      default: '',
      required: false
    },
    title: {
      type: String,
      default: '',
      required: false
    },
    value: {
      type: [String, Number, Array],
      default: '',
      required: false
    }
  },
  data () {
    return {
      response: ''
    }
  },
  computed: {
    computedDate () {
      return this.response ? this.$moment(this.response).format('MMM DD, YYYY') : ''
    }
  },
  watch: {
    value (newVal) {
      this.response = newVal
    },
    response (newVal) {
      this.$emit('input', this.response)
    }
  },
  created () {
    this.response = this.value
  }
}
</script>
<style lang="scss" scoped>
@import '~/assets/css/snui/index.scss';

.sn-date-picker {
  font-family: $font-family-primary !important;
  .v-input--is-disabled {
    ::v-deep .v-input__slot {
      background-color: $sn-gray-01;
      border: 1px solid $sn-gray-04;
      .v-text-field__slot {
        input {
          color: $sn-primary-01 !important;
        }
      }
    }
  }
  ::v-deep {
    font-family: $font-family-primary !important;
    .v-input__slot {
      background-color: $sn-white !important;
      border: 1px solid $sn-gray-04;
      box-sizing: border-box;
      border-radius: 2px;
      min-height: 48px !important;

      & fieldset {
        border: none;
      }

      &:focus-within {
        border: 1px solid $sn-primary !important;
      }

      &:hover {
        border: 1px solid $sn-primary !important;
      }
    }
  }
  .error--text {
    ::v-deep .v-input__slot {
      border-color: #FF5252;

      &:hover {
        border-color: #FF5252 !important;
      }
    }
  }
  ::v-deep .v-text-field__details {
    padding-left: 0 !important;
  }
  ::v-deep .v-messages {
    color: $sn-primary-01;
  }
  ::v-deep .v-text-field__slot {
    input {
      caret-color: $sn-primary;
    }
  }
  ::v-deep .v-input__append-inner {
    margin-top: 10px !important;
  }
  ::v-deep .v-messages {
    color: $sn-primary-01;
    visibility: hidden;

    &.error--text {
      font-size: 15px;
      display: inline-flex;
      align-items: center;
      visibility: visible;

      &:before {
        content: '\26A0';
        margin-right: 5px;
        font-size: 20px;
      }

      .v-messages__wrapper {
        display: inline-flex;
      }
    }
  }
}
</style>
